/* eslint-disable no-debugger */
import React, { useEffect, useState } from 'react';
import { useConfig } from 'base-shell/lib/providers/Config';
import PWAPrompt from 'react-ios-pwa-prompt';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { SnackbarProvider } from 'notistack';
import { IntlProvider, useIntl } from 'react-intl';

import { useTheme } from 'providers/Theme';
import MenuProvider from 'providers/Menu/Provider';
import LoadingProvider from 'providers/Loading';
import ToastProvider from 'providers/Toast';
import AppThemeProvider from 'providers/Theme/Provider';

import AppShell from './AppShell';

import { getLocaleMessages } from 'utils/method';
import getThemeSource from 'utils/theme';
// import locales from 'config/locales';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

const LayoutContent = ({ children }) => {
  const intl = useIntl();
  const { appConfig } = useConfig();
  const { themeID, isDarkMode, isRTL } = useTheme();
  const { theme: themeConfig, pwa, notistack } = appConfig || {};
  const { useiOSPWAPrompt, iOSPWAPromptProps } = pwa || {};
  const { themes = [] } = themeConfig || {};
  const theme = getThemeSource(themeID, themes, isDarkMode, isRTL);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider maxSnack={3} {...notistack}>
        <LoadingProvider>
          <ToastProvider>{children}</ToastProvider>
        </LoadingProvider>
      </SnackbarProvider>
      {useiOSPWAPrompt && false && (
        <PWAPrompt
          //debug={true}
          promptOnVisit={1}
          timesToShow={3}
          copyTitle={intl.formatMessage({
            id: 'ios_prompt_title',
            defaultMessage: 'Add to Home Screen',
          })}
          copyClosePrompt={intl.formatMessage({
            id: 'ios_prompt_close',
            defaultMessage: 'Close',
          })}
          copyBody={intl.formatMessage({
            id: 'ios_prompt_body',
            defaultMessage:
              'This website has app functionality. Add it to your home screen to use it in fullscreen and while offline.',
          })}
          copyShareButtonLabel={intl.formatMessage({
            id: 'ios_prompt_share_button',
            defaultMessage: "1) Press the 'Share' button",
          })}
          copyAddHomeButtonLabel={intl.formatMessage({
            id: 'ios_prompt_add_to_home_button',
            defaultMessage: "2) Press 'Add to Home Screen'",
          })}
          permanentlyHideOnDismiss={false}
          {...iOSPWAPromptProps}
        />
      )}
    </ThemeProvider>
  );
};

export default function LayoutContainer({ children }) {
  const { appConfig } = useConfig();
  const { locale: appLocale } = appConfig || {};
  const { locales } = appLocale || {};
  const lang = (navigator.language || '').toLocaleLowerCase();

  const [messages, setMessages] = useState();

  useEffect(() => {
    const loadMessages = async () => {
      const { default: messages } = await getLocaleMessages(lang, locales);
      setMessages(messages);
    };
    loadMessages();
  }, [lang, locales]);

  if (!messages) return null;

  return (
    <IntlProvider messages={messages} locale={lang} defaultLocale="en">
      <MenuProvider>
        <AppThemeProvider appConfig={appConfig}>
          <LayoutContent>
            <AppShell />
            {children}
          </LayoutContent>
        </AppThemeProvider>
      </MenuProvider>
    </IntlProvider>
  );
}
